<div class="page-layout simple fullwidth" fusePerfectScrollbar *ngIf="translations">

	<app-scrum-bread-bar></app-scrum-bread-bar>
    <div class="content mat-white-bg">
		<mat-card style="overflow: hidden;
		padding: 20px;
		">
			<div class="section-header">{{translations.lblFilter}}</div>
			<div fxLayout="row" fxLayoutAlign="start start">
	            
				<mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="30">
	                <input matInput [matDatepicker]="dp1" placeholder="{{translations.txtFromReceiveDate}}" [(ngModel)]="searchCriteria.FromReceiveDate" readonly>
					<mat-icon *ngIf="searchCriteria.FromReceiveDate != ''" matSuffix (click)="searchCriteria.FromReceiveDate = ''" style="font-size: 15px;cursor: pointer;">close</mat-icon>
	                <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
					<mat-datepicker #dp1 disabled="false"></mat-datepicker>							
            	</mat-form-field>

            	<mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="30">
	                <input matInput [matDatepicker]="dp2" placeholder="{{translations.txtToReceiveDate}}" [(ngModel)]="searchCriteria.ToReceiveDate" [min]="searchCriteria.FromReceiveDate" readonly>
					<mat-icon *ngIf="searchCriteria.ToReceiveDate != ''" matSuffix (click)="searchCriteria.ToReceiveDate = ''" style="font-size: 15px;cursor: pointer;">close</mat-icon>
	                <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
	                <mat-datepicker #dp2 disabled="false"></mat-datepicker>
            	</mat-form-field>


	           <!--  <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="15" >
	                <input #inpFromWeekNumber matInput type="number" min="01" max="53" maxlength="2" placeholder="{{translations.lblFromWeekNumber}}"  
	                value="{{currentDate | date: 'ww'}}" oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength)"
	                (keypress)="appService.onlyPositiveNumber($event)">
	            </mat-form-field>
	            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="15">
	                <input #inpFromYear matInput type="number" min="1900" oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength)" max="{{currentDate | date: 'yyyy'}}"  maxlength="4" placeholder="{{translations.lblFromYear}}" 
	                  value="{{currentDate | date: 'yyyy'}}" (keypress)="appService.onlyPositiveNumber($event)">
	            </mat-form-field>

				        
				<mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="15" >
	                <input #inpToWeekNumber matInput type="number" min="01" max="53" maxlength="2" placeholder="{{translations.lblToWeekNumber}}"  
	                (keypress)="appService.onlyPositiveNumber($event)" oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength)">
	            </mat-form-field>
	            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="15">
	                <input #inpToYear matInput type="number" min="1900" max="{{currentDate | date: 'yyyy'}}"  maxlength="4" placeholder="{{translations.lblToYear}}" 
	                  (keypress)="appService.onlyPositiveNumber($event)" oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength)">
	            </mat-form-field>  -->
	       

	            <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="40">
			        <mat-select #inpOrderStatus placeholder="{{translations.lblOrderStatus}}" [(ngModel)]="searchCriteria.OrderStatus">
			        	<mat-option [value]="0">{{translations.filterOptionAll}}</mat-option>
			            <mat-option *ngFor="let orderStatus of orderStatusList" [value]="orderStatus.Id">{{orderStatus.Text}}</mat-option>
			        </mat-select>
			          <mat-error *ngIf="formGroupErrors.Status.required">
			              {{translations.msgPleaseSelectOrderStatus}}
			          </mat-error>
			    </mat-form-field>
                <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="40">
			        <mat-select #inpCountryCode placeholder="{{translations.lblCountryCode}}" [(ngModel)]="searchCriteria.CountryCode">
			        	<mat-option [value]="0">{{translations.filterOptionAll}}</mat-option>
			            <mat-option *ngFor="let country of countryList" [value]="country.Id">{{country.Code}}</mat-option>
			        </mat-select>
			    </mat-form-field>
			     <button mat-raised-button color="accent" matTooltip="{{translations.lblFilter}}" style="flex: none !important;width:70px !important;color:White;font-weight: bold !important;" (click)="go()">
                        {{translations.btnGet}}
                </button>
	        </div>		
	        <mat-divider></mat-divider>
			<div class="section-header">{{translations.lblSummery}}</div>
			<div fxLayout="row" fxLayoutAlign="start start">
	            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="30" >
	                <input matInput placeholder="{{translations.lblTotalCOD}}" disabled="disabled" 
	                value="{{getTotal('F_CODAmount')  | number : '1.2-2'}}">
	            </mat-form-field>

	            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="30">
					<input matInput placeholder="{{translations.lblTotalTransportInvoice}}" disabled="disabled" 
					value="{{getTotal('F_TransportInvoiceAmount')  | number : '1.2-2'}}">
	            </mat-form-field>

	             <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="30">
	              <input matInput placeholder="{{translations.lblTotalRevenue}}" disabled="disabled" 
	              value="{{getTotal('F_Revenue') | number : '1.2-2'}}">
	            </mat-form-field>
	        </div>
			<mat-divider></mat-divider>
			<div class="section-header" fxLayout="row" fxLayoutAlign="start start"> 
				<div fxLayout="row" fxLayoutAlign="start" style="display: inline-block;width:50%;text-align: left;">{{translations.lblOrders}}</div>
				<div fxLayout="row" fxLayoutAlign="end" style="display: inline-block;width:50%;text-align: right;float: right;"> 
					<button style="background: #1e88e5;color: white;" mat-raised-button #chipActionPdf (click)="exportToPdf()">
						Open orders. <mat-icon style="color: white;">picture_as_pdf</mat-icon>
					</button>
		    	</div> 
		    </div>
			<div fxLayout="row" fxLayoutAlign="start start" style="overflow-x: auto;" *ngIf="data.length > 0">
				<table class="tableFixHead">
					<thead>
						<tr>
							<th class="column-data header action"></th>
						<th class="column-data header" *ngFor="let header of datatableProp.displayedColumns; let i = index;" 
							[ngStyle]="{'text-align': (i > 8  && i < 22) ? 'right' : 'left'}">
							{{ translations[header] }}
						</th>
					</tr>
					</thead>
					<tbody style="overflow-y: auto;height: calc(100vh - 500px);overflow-x: hidden;display: inline-block">
					<tr *ngFor="let row of data" >
						<td class="column-data body action">
							<mat-icon class="edit-record-button" (click)="editRecord($event)" id="{{row['Id']}}">
								edit
							</mat-icon>
						</td>
						<td class="column-data body" *ngFor="let column of getDataArray(row, datatableProp.displayedColumns); let i = index;"
							[ngStyle]="{'text-align': (i > 8 && i < 22) ? 'right' : 'left'}">
							{{ (i > 8 && i < 22) ? (column  | number : '1.2-2') : column }}
						</td>
					</tr>
				</tbody>
					<tr>
						<td class="column-data footer action"></td>
						<td class="column-data footer" *ngFor="let header of datatableProp.displayedColumns; let i = index;" 
							[ngStyle]="{'text-align': (i > 8 && i < 22) ? 'right' : 'left'}">
							{{ (i > 8  && i < 22) ? (getTotal(header)  | number : '1.2-2') : '' }}
						</td>
					</tr>
				</table>	
			</div>
			<div class="no-data" *ngIf="data.length == 0">
				{{gridMessage}}
			</div>
		</mat-card>
    </div>
  
  </div>
  


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/finance/finance.component.html